import type { ActionContext, ActionTree, Store } from "vuex";
import type { State } from "@/store/state";
import type { AssetState } from "./state";
import { eventMonitor } from "@/api/eventMonitor";

type AssetContext = ActionContext<AssetState, State>;

export const actions: ActionTree<AssetState, State> = {
  async actionGetAssets(context: AssetContext): Promise<void> {
    try {
      const response = await eventMonitor.getAssets(
        context.rootState.main.token,
      );
      if (response) {
        context.commit("setAssets", response.data);
      }
    } catch (error) {
      console.log(error);
      context.commit(
        "main/addNotification",
        {
          content: "Error getting assets",
          color: "error",
        },
        { root: true },
      );
    }
  },
};

const NS = "assets/";

export const dispatchActionGetAssets = (store: Store<State>) =>
  store.dispatch(`${NS}actionGetAssets`);
